module.exports = __webpack_public_path__ + "img/PMLogo_fekete.404d0e99.png";